
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/candidates",
      function () {
        return require("private-next-pages/candidates/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/candidates"])
      });
    }
  